import { create } from "zustand";
import { persist } from "zustand/middleware";

type Theme = "light" | "dark";

interface ThemeStore {
    theme: Theme;
    setTheme: (theme: Theme) => void;
    toggleTheme: () => void;
}

const getInitialTheme = (): Theme => {
    if (typeof window !== "undefined") {
        const stored = localStorage.getItem("maeiz-tenant-theme");
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                return parsed?.state?.theme || "dark";
            } catch {
                return "dark";
            }
        }
    }
    return "dark";
};

export const useThemeStore = create<ThemeStore>()(
    persist(
        (set) => ({
            theme: getInitialTheme(),
            setTheme: (theme) => {
                set({ theme });
                if (typeof document !== "undefined") {
                    document.documentElement.classList.remove("light", "dark");
                    document.documentElement.classList.add(theme);
                }
            },
            toggleTheme: () => {
                set((state) => {
                    const newTheme = state.theme === "dark" ? "light" : "dark";
                    if (typeof document !== "undefined") {
                        document.documentElement.classList.remove("light", "dark");
                        document.documentElement.classList.add(newTheme);
                    }
                    return { theme: newTheme };
                });
            },
        }),
        {
            name: "maeiz-tenant-theme",
            storage: {
                getItem: (name) => {
                    const str = localStorage.getItem(name);
                    return str ? JSON.parse(str) : null;
                },
                setItem: (name, value) => {
                    localStorage.setItem(name, JSON.stringify(value));
                },
                removeItem: (name) => {
                    localStorage.removeItem(name);
                },
            },
        }
    )
);

